<template>
<span class="tooltip" ref="anchor"> 
    <span> {{ anchor }}</span> 
    <div class="content" ref="content"  style="display: none;">
        <slot> </slot>
    
    </div>

</span>
</template>

<script>

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

export default {
    props: {
        anchor: {
            type: String,
            default: "?"
        },
        content: {
            type: String,
        }
    },

    mounted() {
        tippy(this.$refs.anchor, {
            content: this.$refs.content.innerHTML,
            allowHTML: true,
            animation: 'perspective',
        })
    }
}
</script>

<style lang="scss" scoped>

.tooltip {
    width: 1.3em;
    height: 1.3em;

    text-align: center;
    font-size: 1em;
    font-weight: 400;

    border: 1px solid var(--col-mainblue);
    border-radius: 50%;
    vertical-align: middle;

    display: inline-flex;
    justify-content: center;
    align-items: center;

    cursor: help;
}
</style>